<template>
  <div class="events">
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">Upcoming Events</h3>
      </div>
      <div class="table-responsive">
        <table class="table card-table table-striped table-vcenter">
          <thead>
            <tr>
              <th>Event</th>
              <th>Venue</th>
              <th>Date</th>
              <th/>
            </tr>
          </thead>
          <tbody>
            <tr v-for="event in events" :key="event.id">
              <td>{{ event.name }}</td>
              <td>{{ event.venue }}</td>
              <td class="text-nowrap">{{ event.startAt }}</td>
              <td class="w-1">
                <router-link :to="{ path: `/${event.id}` }" class="icon">
                  <i class="fe fe-camera"/>
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { Machine } from 'xstate'

import api from '@/services/Api'

const eventsMachine = Machine({
    initial: 'loading',
    states: {
        events: {},
        error: {
            on: {
                RETRY: 'loading',
            },
        },
        loading: {
            on: {
                SUCCESS: 'events',
                FAIL: 'error',
            },
        },
    },
})

export default {
    name: 'Events',
    data: () => ({
        current: eventsMachine.initialState,
        events: [],
    }),
    mounted: function() {
        api.getEvents()
            .then(events => this.transition('SUCCESS', { events }))
            .catch(error => this.transition('FAIL', { error }))
    },
    methods: {
        transition(type, payload) {
            this.current = eventsMachine.transition(this.current, type)
            Object.keys(payload).forEach(key => {
                this[key] = payload[key]
            })
        },
    },
}
</script>
